import { render, staticRenderFns } from "./PerformanceItem.vue?vue&type=template&id=15a58282&scoped=true&"
import script from "./PerformanceItem.vue?vue&type=script&lang=js&"
export * from "./PerformanceItem.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceItem.vue?vue&type=style&index=0&id=15a58282&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a58282",
  null
  
)

export default component.exports